const imdbApikey = '3c818ab4';

export default imdbApikey;
